import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a6290a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "ancestors" }
const _hoisted_2 = { id: "self-container-list-item" }

import { onMounted, onUpdated, ref } from "vue";
import Self from "@/bll/models/Self.mjs";
import GenerationComponent from "./GenerationComponent.vue";
import SelfComponent from "./SelfComponent.vue";
import TreeUtils from "@/bll/tree_utils.mjs";
import ParentComponent from "./ParentComponent.vue";

interface Props {
  self: Self;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FamilyTreeBuilder',
  props: {
    self: {}
  },
  setup(__props: any) {

const treeContainer = ref();



onMounted(() => {
  calculateSelfContainerLeftMargin();
  updateTreeMargin();
});

onUpdated(() => {
  calculateSelfContainerLeftMargin();
  updateTreeMargin();
});

function calculateSelfContainerLeftMargin() {
  const selfNode = treeContainer.value.querySelector(
    "#self-container > #self-node"
  );

  const selfVerticalBarLeft = selfNode
    .querySelector(".vertical-bar")
    .getBoundingClientRect().left;

  const familyTreeContainerBoundingClientRect =
    treeContainer.value.parentElement.getBoundingClientRect();
  const centerOfFamilyTreeContainer =
    (familyTreeContainerBoundingClientRect.left +
      familyTreeContainerBoundingClientRect.right) /
    2;

  var offset = centerOfFamilyTreeContainer - selfVerticalBarLeft;

  treeContainer.value.style.setProperty(
    "--self-container-left-margin",
    2 * offset + "px"
  );
}

function updateTreeMargin() {
  // setTimeout is necessary to properly position tree margin
  setTimeout(() => {
    const firstHalfSiblingContainer = treeContainer.value.querySelector(
      ":scope #ancestors #half-sibling-container-1"
    );

    const fullSiblingsContainer = treeContainer.value.querySelector(
      ":scope #full-siblings-container"
    );
    console.log(fullSiblingsContainer);

    // Only position tree if:
    //  1. firstHalfSiblingContainer, or
    //    a. exists, and
    //    b. is positioned to the left of the treeContainer, so part of the family tree is not visible
    //  2. fullSiblings
    //    a. exists, and
    //    b. is positioned to the left of the treeContainer
    if (
      !isPartiallyHidden(firstHalfSiblingContainer) &&
      !isPartiallyHidden(fullSiblingsContainer)
    ) {
      return;
    }

    const selfNode = treeContainer.value.querySelector(
      "#self-container-list-item"
    );

    var leftMargin = selfNode.getBoundingClientRect().left;
    if (firstHalfSiblingContainer) {
      // Prefer positioning based on firstHalfSiblingContainer if present, since that
      // will always be the left-most component
      leftMargin -= firstHalfSiblingContainer!.getBoundingClientRect().left;
    } else if (fullSiblingsContainer) {
      // Otherwise, position based off of fullSiblingsContainer
      leftMargin -= fullSiblingsContainer!.getBoundingClientRect().left;
    }

    treeContainer.value.style.marginLeft = leftMargin + "px";
  }, 0);
}

function isPartiallyHidden(container: any): boolean {
  return (
    container &&
    container.getBoundingClientRect().left <
      document.querySelector(".family-tree-container")!.getBoundingClientRect()
        .left
  );
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", {
    class: "tree-container",
    ref_key: "treeContainer",
    ref: treeContainer
  }, [
    _createElementVNode("li", _hoisted_1, [
      (_unref(TreeUtils).getAncestors(_ctx.self).length > 0)
        ? (_openBlock(), _createBlock(ParentComponent, {
            key: 0,
            self: _ctx.self,
            parents: _unref(TreeUtils).getAncestors(_ctx.self)
          }, null, 8, ["self", "parents"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("li", _hoisted_2, [
      _createVNode(SelfComponent, {
        member: _ctx.self,
        id: "self-container"
      }, null, 8, ["member"])
    ]),
    _createElementVNode("li", null, [
      (_unref(TreeUtils).getDescendents(_ctx.self))
        ? (_openBlock(), _createBlock(GenerationComponent, {
            key: 0,
            "family-members": _unref(TreeUtils).getDescendents(_ctx.self),
            "is-ascending": false,
            "is-ascention-allowed": false
          }, null, 8, ["family-members"]))
        : _createCommentVNode("", true)
    ])
  ], 512))
}
}

})